
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { bindOperBatch, upDevModel } from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component
export default class EquipmentListMatch extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  private oprList!: object[];
  @Prop({
    default: () => {
      return [];
    }
  })
  private modelList!: object[];

  private formInline: objAny = {
    oprPkId: "",
    deviceModelPkId: "",
    deviceSns: []
  };
  private modalShow = false;
  private loading = true;
  private FormData: objAny = {};
  private modalTitle = i18n.t("equipmentList.bindDev");
  private modalWaitTitle = i18n.t("equipmentList.unBindDev");
  private oprWaitTitle = i18n.t("equipmentList.changeOper");

  private ruleInline: objAny = {
    oprPkId: [
      {
        required: true,
        message: i18n.t("equipmentList.operPl"),
        trigger: "change"
      }
    ],
    deviceModelPkId: [
      {
        required: true,
        message: i18n.t("equipmentList.deviceModelPl"),
        trigger: "change"
      }
    ]
  };

  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("equipmentList.serialNumber"),
      key: "serialNumber",
      resizable: true,
      minWidth: 80
    },
    {
      title: i18n.t("equipmentModel.deviceModelName"),
      key: "deviceModelName",
      resizable: true,
      minWidth: 160
    },
    {
      title: i18n.t("equipmentModel.deviceType"),
      key: "deviceTypeName",
      resizable: true,
      minWidth: 130
    }
  ];
  private devTypeTotal = {};
  private modalType = "";

  public open(list: object[], type: string) {
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formItem"];
      });
    } else {
      this.handleReset();
    }
    const deviceSns: string[] = [];
    const devObj: objAny = {};
    list.map((item: objAny) => {
      deviceSns.push(item.pilePkId);
      if (devObj[item.deviceModelName] == undefined) {
        devObj[item.deviceModelName] = 0;
      }
      devObj[item.deviceModelName] = devObj[item.deviceModelName] + 1;
    });
    this.devTypeTotal = devObj;
    this.formInline.deviceSns = deviceSns;
    this.tableList = list;
    this.modalType = type;
    this.modalShow = true;
    if (type === "oper") {
      this.modalTitle = i18n.t("operation");
      this.modalWaitTitle = i18n.t("equipmentList.unBindDev");
      this.oprWaitTitle = i18n.t("equipmentList.bindOper");
    } else {
      this.modalTitle = i18n.t("equipmentList.changeModel");
      this.modalWaitTitle = i18n.t("equipmentList.noChangeOper");
      this.oprWaitTitle = i18n.t("equipmentList.changeModel");
    }
  }

  public handleSubmit(): void {
    this.loading = true;
    this.FormData.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      } else {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      }
    });
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  public handleReset() {
    this.FormData.resetFields();
  }
  async submitData(): Promise<void> {
    let ret: objAny;
    if (this.modalType == "oper") {
      ret = await bindOperBatch(this.formInline);
    } else {
      ret = await upDevModel(this.formInline);
    }
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.closeModal();
    }
    this.loading = false;
  }
}
